'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Breadcrumbs = exports.BreadcrumbsItem = exports.BreadcrumbsProvider = exports.Item = exports.Dummy = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _class2, _temp, _initialiseProps, _class3, _temp2;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.withBreadcrumbs = withBreadcrumbs;
exports.withBreadcrumbsItem = withBreadcrumbsItem;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBroadcast = require('react-broadcast');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_DATA_NUM = 1000000;

function withBreadcrumbs(BreadcrumbsComponent) {
  var Breadcrumbs = function Breadcrumbs(props, context) {
    return _react2.default.createElement(
      _reactBroadcast.Subscriber,
      { channel: 'breadcrumbs' },
      function (breadcrumbs) {
        return _react2.default.createElement(BreadcrumbsComponent, _extends({}, props, { breadcrumbs: breadcrumbs }));
      }
    );
  };
  return Breadcrumbs;
}

function withBreadcrumbsItem(BreadcrumbsComponent) {
  var WithBreadcrumbsItem = function (_React$Component) {
    _inherits(WithBreadcrumbsItem, _React$Component);

    function WithBreadcrumbsItem(props, context) {
      _classCallCheck(this, WithBreadcrumbsItem);

      var _this = _possibleConstructorReturn(this, (WithBreadcrumbsItem.__proto__ || Object.getPrototypeOf(WithBreadcrumbsItem)).call(this, props, context));

      _this.componentWillMount = function () {
        _this.update(_this.data);
      };

      _this.componentWillUnmount = function () {
        _this.update({});
      };

      _this.item = function (elem) {
        var data = !elem || !elem.props.to ? {} : _defineProperty({}, elem.props.to, elem.props);
        _this.update(data);
      };

      _this.items = function (elem) {
        var data = {};
        _react2.default.Children.forEach(elem.props.children, function (elem) {
          if (!elem || !elem.props.to) {
            return;
          }
          data[elem.props.to] = elem.props;
        });
        _this.update(data);
      };

      _this.update = function (data) {
        var remove = Object.keys(_this.data).filter(function (to) {
          return !data.hasOwnProperty(to);
        });
        remove.forEach(function (to) {
          return _this.props.breadcrumbs.remove(to);
        });
        Object.keys(data).forEach(function (to) {
          return _this.props.breadcrumbs.install(to, data[to], true);
        });
        _this.data = data;
      };

      _this.data = {};
      return _this;
    }

    _createClass(WithBreadcrumbsItem, [{
      key: 'render',
      value: function render() {
        var item = this.item,
            items = this.items;

        var bc = Object.assign({ item: item, items: items }, this.props.breadcrumbs);
        return _react2.default.createElement(BreadcrumbsComponent, _extends({}, this.props, { breadcrumbs: bc }));
      }
    }]);

    return WithBreadcrumbsItem;
  }(_react2.default.Component);

  return withBreadcrumbs(WithBreadcrumbsItem);
}

var Dummy = exports.Dummy = function Dummy() {
  return null;
};
var Item = exports.Item = function Item() {
  return null;
};

var BreadcrumbsProvider = exports.BreadcrumbsProvider = (_temp = _class2 = function (_React$Component2) {
  _inherits(BreadcrumbsProvider, _React$Component2);

  function BreadcrumbsProvider(props) {
    _classCallCheck(this, BreadcrumbsProvider);

    var _this2 = _possibleConstructorReturn(this, (BreadcrumbsProvider.__proto__ || Object.getPrototypeOf(BreadcrumbsProvider)).call(this, props));

    _initialiseProps.call(_this2);

    _this2.state = {
      dataNum: MAX_DATA_NUM
    };
    _this2.data = {};
    _this2.timer = undefined;
    _this2.dataNum = MAX_DATA_NUM;
    _this2.mounted = false;
    return _this2;
  }

  _createClass(BreadcrumbsProvider, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.canSetState = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.canSetState = false;
    }
  }, {
    key: 'doUpdate',
    value: function doUpdate(syncUpdate) {
      var _this3 = this;

      ++this.dataNum;

      if (syncUpdate) {
        if (this.canSetState) {
          this.setState({ dataNum: this.dataNum });
        }
        return;
      }

      if (!this.timer) {
        this.timer = setTimeout(function () {
          if (_this3.dataNum > MAX_DATA_NUM) {
            _this3.dataNum = 0;
          }
          if (_this3.canSetState) {
            _this3.setState({ dataNum: _this3.dataNum });
          }
          _this3.timer = undefined;
        }, 0);
      }
    }
  }, {
    key: '_diffAndComplicatedCounts',
    value: function _diffAndComplicatedCounts(prevProps, props) {
      var keys = Object.keys(prevProps).concat(Object.keys(props));
      // reflect types in the documentation if changed
      var quicks = ['string', 'number', 'undefined', 'boolean', 'symbol'];

      var _keys$reduce = keys.reduce(function (stat, k) {
        return [stat[0] + (prevProps[k] !== props[k] ? 1 : 0), stat[1] + (!quicks.includes(_typeof(props[k])) ? 1 : 0)];
      }, [0, 0]),
          _keys$reduce2 = _slicedToArray(_keys$reduce, 2),
          diff = _keys$reduce2[0],
          comp = _keys$reduce2[1];

      return [diff, comp];
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactBroadcast.Broadcast,
        { channel: 'breadcrumbs', value: {
            data: this.data,
            install: this.install,
            remove: this.remove
          } },
        this.props.children
      );
    }
  }]);

  return BreadcrumbsProvider;
}(_react2.default.Component), _class2.propTypes = {
  shouldBreadcrumbsUpdate: _propTypes2.default.func
}, _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.install = function (to, props) {
    var syncUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    if (!(typeof to === 'string' || to instanceof String) || !(props instanceof Object && !(props instanceof Array))) {
      throw new Error("type error: breadcrumbs.install(to:string, props:Object)");
    }

    var prevProps = _this4.data[to] || {};

    if (_this4.props.shouldBreadcrumbsUpdate) {
      var diff = _this4.props.shouldBreadcrumbsUpdate(prevProps, props);

      if (!diff) return;

      syncUpdate = true;
    } else {
      var _diffAndComplicatedCo = _this4._diffAndComplicatedCounts(prevProps, props),
          _diffAndComplicatedCo2 = _slicedToArray(_diffAndComplicatedCo, 2),
          _diff = _diffAndComplicatedCo2[0],
          comp = _diffAndComplicatedCo2[1];

      if (!_diff) return;

      if (undefined === syncUpdate) {
        syncUpdate = !comp;
      }
    }

    var data = Object.assign({}, _this4.data);
    data[to] = _extends({}, props);
    _this4.data = data;
    _this4.doUpdate(syncUpdate);
  };

  this.remove = function (to) {
    if (_this4.data.hasOwnProperty(to)) {
      var data = Object.assign({}, _this4.data);
      delete data[to];
      _this4.data = data;
      _this4.doUpdate(true);
    }
  };
}, _temp);
var BreadcrumbsItem_ = (_temp2 = _class3 = function (_React$Component3) {
  _inherits(BreadcrumbsItem_, _React$Component3);

  function BreadcrumbsItem_(props) {
    _classCallCheck(this, BreadcrumbsItem_);

    var _this5 = _possibleConstructorReturn(this, (BreadcrumbsItem_.__proto__ || Object.getPrototypeOf(BreadcrumbsItem_)).call(this, props));

    var _props$breadcrumbs = props.breadcrumbs,
        install = _props$breadcrumbs.install,
        remove = _props$breadcrumbs.remove;

    _this5.install = install;
    _this5.remove = remove;
    return _this5;
  }

  _createClass(BreadcrumbsItem_, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          breadcrumbs = _props.breadcrumbs,
          props = _objectWithoutProperties(_props, ['breadcrumbs']);

      this.install(props.to, props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var breadcrumbs = _ref2.breadcrumbs,
          nextProps = _objectWithoutProperties(_ref2, ['breadcrumbs']);

      var props = _objectWithoutProperties(this.props, []);

      delete props.breadcrumbs;
      if (this.props.to !== nextProps.to) {
        this.remove(this.props.to);
      }
      this.install(nextProps.to, nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.remove(this.props.to);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return BreadcrumbsItem_;
}(_react2.default.Component), _class3.propTypes = {
  to: _propTypes2.default.string.isRequired
}, _temp2);
var BreadcrumbsItem = exports.BreadcrumbsItem = withBreadcrumbs(BreadcrumbsItem_);

function propsRenAndDup(props, ren, dup) {
  var p = Object.assign({}, props);
  Object.keys(dup).forEach(function (k) {
    p[dup[k]] = p[k];
  });
  Object.keys(ren).forEach(function (k) {
    p[ren[k]] = p[k];delete p[k];
  });
  return p;
}

var Breadcrumbs_ = function Breadcrumbs_(props) {
  var data = props.breadcrumbs.data;

  var pathnames = Object.keys(data).sort(function (a, b) {
    return a.length - b.length;
  });

  var Container = props.container || 'span';
  var containerProps = props.containerProps;
  var Item = props.item || 'a';
  var FinalItem = props.finalItem || Item;
  var finalProps = props.finalProps || {};
  var separator = props.separator;
  var count = pathnames.length;
  var ren = props.renameProps || {};
  var dup = props.duplicateProps || {};

  return _react2.default.createElement(
    Container,
    containerProps,
    pathnames.map(function (pathname, i) {
      return i + 1 < count ? separator ? _react2.default.createElement(
        'span',
        { key: i },
        _react2.default.createElement(Item, propsRenAndDup(data[pathname], ren, dup)),
        separator
      ) : _react2.default.createElement(Item, _extends({ key: i }, propsRenAndDup(data[pathname], ren, dup))) : _react2.default.createElement(FinalItem, _extends({ key: i
      }, propsRenAndDup(data[pathname], ren, dup), finalProps));
    })
  );
};

var Breadcrumbs = exports.Breadcrumbs = withBreadcrumbs(Breadcrumbs_);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-breadcrumbs-dynamic/dist/src/index.js
// module id = 80
// module chunks = 0